import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { theme } from 'Providers/ThemeProvider'

export type CardType = 'active' | 'warning' | 'expired' | 'error'

interface IStatusCardProps extends Omit<BoxProps, 'children'> {
  disableBgColor?: boolean
  label: string
  type: CardType
}

const getBackgroundColor = (type: CardType) => {
  let bgColor = theme.palette.warning.main
  switch (type) {
    case 'active':
      bgColor = theme.palette.success.light
      break
    case 'error':
      bgColor = theme.palette.error.main
      break
    case 'expired':
      bgColor = theme.palette.grey[500]
      break
    default:
      break
  }
  return bgColor
}

const StatusCard = ({
  label,
  type,
  minWidth = 100,
  disableBgColor = false,
  ...rest
}: IStatusCardProps) => {
  return (
    <Box
      sx={{
        padding: '0px 16px',
        borderRadius: 1,
        fontWeight: '900',
      }}
      minWidth={minWidth}
      textAlign={disableBgColor ? 'left' : 'center'}
      bgcolor={disableBgColor ? 'inherit' : getBackgroundColor(type)}
      color={
        !disableBgColor ? theme.palette.common.white : getBackgroundColor(type)
      }
      {...rest}
    >
      {label}
    </Box>
  )
}

export default StatusCard
